module.exports = __webpack_public_path__ + "c92d813d713f5ca78d2c62ccd9b67c3d.jpg";